export const CASHFREE_CONFIG = {
  MODE: process.env.REACT_APP_CASHFREE_ENV || "sandbox",
  options: {
    currency: "INR",
    name: "InfinityWhale",
    description: "Premium Shopping Experience",
  },
};
